import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { postTransactions } from 'services/easyPay'

export default function useSetTransactionsWallet(jsonData: any) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ITransactionPayload) => {
            return postTransactions(payload)
        },
        onSuccess: (result, variables) => {
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    type: 'pay-for-others',
                    data: jsonData ? jsonData : [],
                    //@ts-ignore
                    pk: result?.pk,
                    //@ts-ignore
                    gateway: result?.gateway,
                })
            )
            //@ts-ignore
            window.location.replace(result?.pay_url)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutateTransactionWallet: mutate }
}
